module.exports = __webpack_public_path__ + "static/media/Select_Investor_Image.6fb42df0.png";